import {brandError} from "../../../../assets/consts/color";
import styled from "styled-components";

const Form = styled.form`
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    margin-bottom: 24px;
`

const BodyWrapper = styled.div`
    display: flex;
    gap: 24px;
    flex-wrap: wrap;
    justify-content: space-between;

    span,
    label {
        line-height: 115%;
    }

    @media only screen and (max-width: 48em) {
        gap: 12px;
    }
`

const FieldWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;

    & > div {
        flex: 1;
    }

    width: 100%;

    @media only screen and (min-width: 48em) and (max-width: 1450px) {
        width: 100% !important;
    }

    @media only screen and (min-width: 48em) {
        flex: ${(props) => (props?.half ? 'calc(50% - 24px)' : 'auto')};
    }
`

const FieldItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    line-height: 0;

    position: relative;
    & > div:first-child:not(.input-wrapper) {
        width: 100%;
    }

    .input-wrapper {
        width: 100%;

        label {
            position: relative;
        }

        label[aria-required='true']::after {
            position: absolute;
            top: 0;
            right: -10px;
            content: '*';
            color: ${brandError};
        }

        .error {
            font-size: 16px;
            color: ${brandError};
        }
    }
`

const CandidateWrapper = styled.div`
    h4 {
        width: 100%;
    }
    
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    width: 100%;
`

export { Form, BodyWrapper, FieldWrapper, FieldItem, CandidateWrapper }